const state = {
 current_order_id: null,
 current_order_tab_index: 0,
 
 reload_order: false,
 
 create_order_company_id: null,
 
 order_steps: {
  basic_info: {
   icon: 'fas fa-info',
   text: 'Basic Information',
   active: true,
   completed: false,
   errors: false,
   component_name: 'basic_info',
   partial_order_complete: false,
   data: null
  },
  job_locations: {
   icon: 'fas fa-map-marked-alt',
   text: 'Job Locations',
   active: false,
   completed: false,
   errors: false,
   component_name: 'job_locations',
   partial_order_complete: false,
   data: null
  },
  positions_rates: {
   icon: 'fas fa-user-tag',
   text: 'Position(s) & Rate(s)',
   active: false,
   completed: false,
   errors: false,
   component_name: 'position_rates',
   partial_order_complete: false,
   data: null
  },
  timesheet_authorisation: {
   icon: 'fas fa-business-time',
   text: 'Timesheet Authorisation & Accounts',
   active: false,
   completed: false,
   errors: false,
   component_name: 'timesheet_authorisation',
   partial_order_complete: false,
   data: null
  },
  compliance_terms: {
   icon: 'fas fa-clipboard-check',
   text: 'Compliance & Terms',
   active: false,
   completed: false,
   errors: false,
   component_name: 'compliance_terms',
   partial_order_complete: false,
   data: null
  },
  publish_information: {
   icon: 'fas fa-pen-nib',
   text: 'Publish Information',
   active: false,
   completed: false,
   errors: false,
   component_name: 'publish_information',
   partial_order_complete: false,
   data: null
  },
  review_order: {
   icon: 'fas fa-search',
   text: 'Review Order',
   active: false,
   completed: false,
   errors: false,
   component_name: 'review_order',
   partial_order_complete: false,
   data: null
  }
 },
 
 copy_order_job_id: null,
};

const actions = {};

const mutations = {
 CURRENT_ORDER_ID(state, order_id) {
  state.current_order_id = order_id
 },
 SET_ORDER_TAB_INDEX(state, tab_index) {
  state.current_order_tab_index = tab_index
 },
 RELOAD_ORDER(state, payload) {
  state.reload_order = payload.action;
 },
 
 SAVE_BASIC_INFO_COMPLETED(state, payload) {
  state.order_steps.basic_info.completed = true;
  state.order_steps.basic_info.errors = false;
  // save data for step
  state.order_steps.basic_info.partial_order_complete = true;
  state.order_steps.basic_info.data = payload;
  // switch to next tab
  state.order_steps.basic_info.active = false;
  state.order_steps.job_locations.active = true;
 },
 SAVE_BASIC_INFO_ERRORS(state, payload) {
  state.order_steps.basic_info.completed = false;
  state.order_steps.basic_info.errors = true;
  // save data for step
  state.order_steps.basic_info.partial_order_complete = true;
  state.order_steps.basic_info.data = payload;
 },
 
 SAVE_JOB_LOCATIONS_COMPLETED(state, payload) {
  state.order_steps.job_locations.completed = true;
  state.order_steps.job_locations.errors = false;
  // save data for step
  state.order_steps.job_locations.partial_order_complete = true;
  state.order_steps.job_locations.data = payload;
  // switch to next tab
  state.order_steps.job_locations.active = false;
  state.order_steps.positions_rates.active = true;
 },
 SAVE_JOB_LOCATIONS_ERRORS(state, payload) {
  state.order_steps.job_locations.completed = false;
  state.order_steps.job_locations.errors = true;
  // save data for step
  state.order_steps.job_locations.partial_order_complete = true;
  state.order_steps.job_locations.data = payload;
 },
 
 SAVE_POSITION_RATES_COMPLETED(state, payload) {
  state.order_steps.positions_rates.completed = true;
  state.order_steps.positions_rates.errors = false;
  // save data for step
  state.order_steps.positions_rates.partial_order_complete = true;
  state.order_steps.positions_rates.data = payload;
  // switch to next tab
  state.order_steps.positions_rates.active = false;
  state.order_steps.timesheet_authorisation.active = true;
 },
 SAVE_POSITION_RATES_ERRORS(state, payload) {
  state.order_steps.positions_rates.completed = false;
  state.order_steps.positions_rates.errors = true;
  // save data for step
  state.order_steps.positions_rates.partial_order_complete = true;
  state.order_steps.positions_rates.data = payload;
 },
 
 SAVE_TIMESHEET_AUTHORISATIONS_COMPLETED(state, payload) {
  state.order_steps.timesheet_authorisation.completed = true;
  state.order_steps.timesheet_authorisation.errors = false;
  // save data for step
  state.order_steps.timesheet_authorisation.partial_order_complete = true;
  state.order_steps.timesheet_authorisation.data = payload;
  // switch to next tab
  state.order_steps.timesheet_authorisation.active = false;
  state.order_steps.compliance_terms.active = true;
 },
 COPY_ORDER_NO_POSITIONS_TIMESHEET_AUTHORISATIONS_COMPLETED(state, payload) {
  state.order_steps.timesheet_authorisation.completed = true;
  state.order_steps.timesheet_authorisation.errors = false;
  // save data for step
  state.order_steps.timesheet_authorisation.partial_order_complete = true;
  state.order_steps.timesheet_authorisation.data = payload;
  // switch to next tab
  state.order_steps.timesheet_authorisation.active = true;
  // state.order_steps.compliance_terms.active = true;
 },
 SAVE_TIMESHEET_AUTHORISATIONS_ERRORS(state, payload) {
  state.order_steps.timesheet_authorisation.completed = false;
  state.order_steps.timesheet_authorisation.errors = true;
  // save data for step
  state.order_steps.timesheet_authorisation.partial_order_complete = true;
  state.order_steps.timesheet_authorisation.data = payload;
 },
 
 SAVE_COMPLIANCE_TERMS_COMPLETED(state, payload) {
  state.order_steps.compliance_terms.completed = true;
  state.order_steps.compliance_terms.errors = false;
  // save data for step
  state.order_steps.compliance_terms.partial_order_complete = true;
  state.order_steps.compliance_terms.data = payload;
  // switch to next tab
  state.order_steps.compliance_terms.active = false;
  state.order_steps.publish_information.active = true;
 },
 SAVE_COMPLIANCE_TERMS_ERRORS(state, payload) {
  state.order_steps.compliance_terms.completed = false;
  state.order_steps.compliance_terms.errors = true;
  // save data for step
  state.order_steps.compliance_terms.partial_order_complete = true;
  state.order_steps.compliance_terms.data = payload;
 },
 
 SAVE_PUBLISH_INFORMATION_COMPLETED(state, payload) {
  state.order_steps.publish_information.completed = true;
  state.order_steps.publish_information.errors = false;
  // save data for step
  state.order_steps.publish_information.partial_order_complete = true;
  state.order_steps.publish_information.data = payload;
  // switch to next tab
  state.order_steps.publish_information.active = false;
  state.order_steps.review_order.active = true;
 },
 SAVE_PUBLISH_INFORMATION_ERRORS(state, payload) {
  state.order_steps.publish_information.completed = false;
  state.order_steps.publish_information.errors = true;
  // save data for step
  state.order_steps.publish_information.partial_order_complete = true;
  state.order_steps.publish_information.data = payload;
 },
 
 RESET_ORDER_STEPS(state) {
  state.create_order_company_id = null;
  state.order_steps = {
   basic_info: {
    icon: 'fas fa-info',
    text: 'Basic Information',
    active: true,
    completed: false,
    errors: false,
    component_name: 'basic_info',
    partial_order_complete: false,
    data: null
   },
   job_locations: {
    icon: 'fas fa-map-marked-alt',
    text: 'Job Locations',
    active: false,
    completed: false,
    errors: false,
    component_name: 'job_locations',
    partial_order_complete: false,
    data: null
   },
   positions_rates: {
    icon: 'fas fa-user-tag',
    text: 'Position(s) & Rate(s)',
    active: false,
    completed: false,
    errors: false,
    component_name: 'position_rates',
    partial_order_complete: false,
    data: null
   },
   timesheet_authorisation: {
    icon: 'fas fa-business-time',
    text: 'Timesheet Authorisation & Accounts',
    active: false,
    completed: false,
    errors: false,
    component_name: 'timesheet_authorisation',
    partial_order_complete: false,
    data: null
   },
   compliance_terms: {
    icon: 'fas fa-clipboard-check',
    text: 'Compliance & Terms',
    active: false,
    completed: false,
    errors: false,
    component_name: 'compliance_terms',
    partial_order_complete: false,
    data: null
   },
   publish_information: {
    icon: 'fas fa-pen-nib',
    text: 'Publish Information',
    active: false,
    completed: false,
    errors: false,
    component_name: 'publish_information',
    partial_order_complete: false,
    data: null
   },
   review_order: {
    icon: 'fas fa-search',
    text: 'Review Order',
    active: false,
    completed: false,
    errors: false,
    component_name: 'review_order',
    partial_order_complete: false,
    data: null
   }
  }
 },
 
 SET_CREATE_ORDER_COMPANY_ID(state, company_id) {
  state.create_order_company_id = company_id
 },
 
 COPY_ORDER_JOB_ID(state, order_job_id) {
  state.copy_order_job_id = order_job_id
 }
};

export default {
 state,
 actions,
 mutations
}
